import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { FormGroup, Label } from "reactstrap";
import { DatePicker } from "@material-ui/pickers";

const dateFormat = "DD-MM-YYYY";
const Date = ({ label, value, onChange, minDate }) => {
  return (
    <DatePicker
      variant="inline"
      label={label}
      format={dateFormat}
      value={moment(value, dateFormat)}
      minDate={moment(minDate, dateFormat)}
      autoOk
      minDateMessage="Fecha no valida"
      invalidDateMessage="Fecha no valida"
      onChange={momentDate => {
        onChange(momentDate.format(dateFormat));
      }}
    />
  );
};

Date.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  minDate: PropTypes.string
};

Date.defaultProps = {
  label: "",
  value: moment().format(dateFormat),
  onChange: () => {},
  minDate: "01-01-1900"
};

const DateTime = ({ id, label, startDate, endDate, onFilterChange }) => {
  const [innerStartDate, setInnerStartDate] = useState(startDate);
  const [innerEndDate, setInnerEndDate] = useState(endDate);
  useEffect(() => {
    if (innerStartDate !== startDate || innerEndDate !== endDate) {
      onFilterChange({
        startDate: innerStartDate,
        endDate: innerEndDate
      });
    }
    // no añadimos onFilterChange para evitar lanzar efectos no deseados con la funcion.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [innerStartDate, innerEndDate]);
  return (
    <FormGroup className="boolean-filter-container d-flex justify-content-between align-items-center">
      <Label className="boolean-filter-label" for={id}>
        {label}
      </Label>
      <div className="date-filter">
        <Date
          label="Fecha inicio"
          value={innerStartDate}
          onChange={newValue => setInnerStartDate(newValue)}
        />
        <Date
          label="Fecha fin"
          value={innerEndDate}
          onChange={newValue => setInnerEndDate(newValue)}
          minDate={innerStartDate}
        />
      </div>
    </FormGroup>
  );
};

DateTime.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  onFilterChange: PropTypes.func
};

DateTime.defaultProps = {
  id: "",
  label: "",
  startDate: moment().format(dateFormat),
  endDate: moment().format(dateFormat),
  onFilterChange: () => {}
};

export default DateTime;
